import {serialize} from "../../../helpers/helpers";
import {apiRequest} from "../../../apiHelper/apiRequest";

/**
 * Method get token
 *
 * @params object   object parameters url request
 * @returns function  object of responce
 */
const getToken = async params => {
    return apiRequest(
        "/token?" + serialize(params),
        {method: "GET"},
        "auth",
        false,
        null,
        false
    );
};


/**
 * Method get user data
 *
 * @params object   object parameters url request
 * @returns function  object of responce
 */
const getUserInfo = async (params) => {
    return apiRequest(
        "/userinfo?" + serialize(params),
        {method: "GET"},
        "auth",
        true,
        (token) => {
            return {
                url: "/userinfo?" + serialize({
                    access_token: token
                }),
                options: {
                    method: "GET"
                },
                sluice_type: 'auth'
            }
        },
        false
    );
};


/**
 * Method save user data
 *
 * @params  params obj
 * @returns func  object of responce
 */
const saveUserInfo = async params => {
    return apiRequest(
        "/users/save-user-info?",
        {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        },
        "ptp_client",
        true,
        null,
        false
    );
}

const exported_method_api = {
    getToken,
    getUserInfo,
    saveUserInfo,
};

export default exported_method_api;